// example of image url from AKAMAI
// https://edgmedia.bws.com.au/bws/media/products/696_0_9999.png?impolicy=Prod_SM

function bwsImageController($scope, $element, SettingsService, retinaDetectionService) {
    this.$onInit = function() {
        const vm = this;
        let mediaDomainNames;
        vm.imgSrc = '';
        vm.imgSrcset = '';
        this.$element = $element;
    
        function initSource() {
            if (vm.imgSize && mediaDomainNames) {
                if (!vm.imgName) {
                    vm.imgName = 'default.png';
                }
    
                vm.imgSize = vm.imgSize.toUpperCase();
    
                const source = mediaDomainNames + 'products/' + vm.imgName;
                const imgUrl = source + '?impolicy=Prod_' + vm.imgSize;
                const imgUrlRetina = vm.imgSize === 'LG' ? imgUrl : (source + '?impolicy=Prod_Retina_' + vm.imgSize);
    
                // default image
                vm.isRetina = retinaDetectionService.isRetina;
                vm.imgSrc = vm.isRetina ? imgUrlRetina : imgUrl;
            }
        }
    
        function getDomainSettings() {
            SettingsService.getSettingValue('OneSite', 'MediaDomainNames').then(function (settingMediaDomainNames) {
            mediaDomainNames = settingMediaDomainNames;
            initSource();
            });
        }
    
        getDomainSettings();
  
        $scope.$watch('vm.imgName', (newValue) => {
            if (newValue) {
                getDomainSettings();
            }
        });
    };
 }
 
 module.exports = {
       bindings: {
          imgAlt: '@?',
          imgClass: '@?',
          imgName: '=?',
          imgSize: '@',
          lazyLoad: '@'
       },
       controller: ['$scope', '$element', 'SettingsService', 'RetinaDetectionService', bwsImageController],
       controllerAs: 'vm',
       template: require('./bws-image-template.html')
 };
 


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/images/bws-image-directive.js
 **/